import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../../api';

export function useStorageContacts() {
  return useQuery(['storageContacts'], async () => {
    try {
      const apiResult = await apiGet(`storage/contacts?v=${Date.now()}`);
      if (apiResult.ok) {
        return apiResult.json();
      }

      throw new Error('Unable to fetch lots');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return null;
    }
  });
}
